import isImageOptimizable from '@/utils/isImageOptimizable';
import Image from 'next/image';
import { CSSProperties } from 'react';

function ImageOrImg({
  src,
  width,
  height,
  objectFit,
  alt,
  className,
  ...props
}: {
  src: string,
  width: number,
  height: number,
  objectFit?: CSSProperties['objectFit'],
  alt?: string,
  className?: string,
}) {
  let pathname = src;
  try {
    pathname = new URL(src)?.pathname;
    // if src is image placeholder (relative path), new URL will throw error
  } catch (e) {
    // do nothing
  }

  if (pathname.endsWith('.svg') || !isImageOptimizable(src)) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={src}
        style={{
          width,
          height,
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit,
        }}
        alt={alt}
        className={className}
        {...props}
      />
    );
  }
  return (
    <div style={{
      width,
      height,
      maxWidth: '100%',
      maxHeight: '100%',
      position: 'relative',
    }}
    >
      <Image
        src={src}
        width={width}
        height={height}
        alt={alt}
        fill={!width}
        style={{
          objectFit,
        }}
        className={className}
        {...props}
      />
    </div>
  );
}

ImageOrImg.defaultProps = {
  objectFit: 'cover',
  alt: 'web image',
  className: '',
};

export default ImageOrImg;
